export const ENTRY_ID = '6uvfEUUMHx9IJzTHOlyeHA'

/** URL segment after `/reports/k8/` for lesson-completion flag.on routes */
export const K8_REPORT_UNIT_SECTION = {
  CORE_UNITS: 'core_units',
  SPECIALIZED_UNITS: 'specialized_units',
}

export const DEFAULT_K8_REPORT_UNIT_SECTION = K8_REPORT_UNIT_SECTION.CORE_UNITS

export const isK8ReportUnitSection = value =>
  value === K8_REPORT_UNIT_SECTION.CORE_UNITS ||
  value === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS

/**
 * Flag.on K8 URLs must be `/reports/k8/<core_units|specialized_units>/…`.
 * When the segment after `k8` is missing or not a valid unit section, returns
 * the pathname to navigate to (default unit `core_units`), preserving legacy
 * grade slugs when present. Returns null when the URL already has a valid unit segment.
 */
export function getK8ReportFlagOnRedirectTarget(pathname) {
  const parts = pathname?.split('/').filter(Boolean) || []
  if (parts[0] !== 'reports' || parts[1] !== 'k8') {
    return null
  }

  const defaultUnitPath = `/reports/k8/${DEFAULT_K8_REPORT_UNIT_SECTION}`

  if (parts.length <= 2) {
    return defaultUnitPath
  }

  const isGradeLikeSlug = slug =>
    slug?.startsWith('grade-') || slug?.startsWith('tier2-')

  const third = parts[2]

  if (isK8ReportUnitSection(third)) {
    const fourth = parts[3]
    if (fourth && isGradeLikeSlug(fourth)) {
      return `/reports/k8/${third}`
    }
    return null
  }

  // Legacy flag.off-style paths: /reports/k8/grade-k or /reports/k8/tier2-…
  if (parts.length === 3 && isGradeLikeSlug(third)) {
    return defaultUnitPath
  }

  const fourth = parts[3]
  if (fourth && isGradeLikeSlug(fourth)) {
    return defaultUnitPath
  }

  return defaultUnitPath
}

// we can consolidate these maps to unify the keys we use
export const K8_GRADE_NAME_TO_GRADE_SLUG_MAP = {
  Kindergarten: 'grade-k', // keep this extra mapping in so mock data works
  'Grade K': 'grade-k',
  'Grade 1': 'grade-1',
  'Grade 2': 'grade-2',
  'Grade 3': 'grade-3',
  'Grade 4': 'grade-4',
  'Grade 5': 'grade-5',
  'Grade 6': 'grade-6',
  'Grade 7': 'grade-7',
  'Grade 8': 'grade-8',
}
